import { Controller } from "@hotwired/stimulus"
import {
  runAction, showProgressModal, hideProgressModal,
  addProgressStep, updateProgressBar, buildSubscriptionOptionsHtml,
} from "../js/admin_action_runner"

export default class extends Controller {
  static targets = [
    "debugResults", "progressModal", "progressTitle",
    "progressSteps", "progressBar", "subscriptionSelector", "subscriptionOptions",
  ]

  static values = { refreshUrl: String, executeUrl: String }

  connect() {
    this.subscriptionSelectorData = null
  }

  refresh() {
    this.debugResultsTarget.innerHTML =
      '<div class="flex justify-center py-8"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div></div>'

    fetch(this.refreshUrlValue, {
      method: "GET",
      headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
    })
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html")
        const newResults = doc.getElementById("debug-results")
        if (newResults) this.debugResultsTarget.innerHTML = newResults.innerHTML
      })
      .catch(() => {
        this.debugResultsTarget.innerHTML =
          '<div class="bg-red-50 p-4 rounded-md"><p class="text-red-800">Error refreshing. Please reload the page.</p></div>'
      })
  }

  executeAction(event) {
    const button = event.currentTarget
    let actionData
    try {
      actionData = JSON.parse(button.dataset.actionData)
    } catch {
      return
    }
    this._runAction(button.dataset.actionType, actionData)
  }

  _runAction(actionType, actionData) {
    const modal = this.progressModalTarget
    const title = this.progressTitleTarget
    const steps = this.progressStepsTarget
    const bar = this.progressBarTarget

    showProgressModal(modal, title, steps, bar, actionType)
    addProgressStep(steps, "Starting action...", "in-progress")
    updateProgressBar(bar, 20)

    runAction(this.executeUrlValue, actionType, actionData, {
      onStart: () => {},
      onSelection: (result) => {
        addProgressStep(steps, "Multiple subscriptions found", "completed")
        updateProgressBar(bar, 100)
        setTimeout(() => {
          hideProgressModal(modal)
          this._showSelector(result)
        }, 1000)
      },
      onSuccess: (result) => {
        addProgressStep(steps, result.message, "completed")
        updateProgressBar(bar, 100)
        setTimeout(() => {
          hideProgressModal(modal)
          this.refresh()
        }, 1500)
      },
      onError: (result) => {
        addProgressStep(steps, result.message, "error")
        updateProgressBar(bar, 100)
        setTimeout(() => hideProgressModal(modal), 3000)
      },
    })
  }

  _showSelector(result) {
    this.subscriptionSelectorData = result.data
    this.subscriptionOptionsTarget.innerHTML =
      buildSubscriptionOptionsHtml(result.subscription_options, "admin-fix-subscription")
    this.subscriptionSelectorTarget.classList.remove("hidden")
  }

  selectSubscription(event) {
    this.subscriptionSelectorTarget.classList.add("hidden")
    const actionData = Object.assign({}, this.subscriptionSelectorData, {
      stripe_subscription_id: event.currentTarget.dataset.subscriptionId,
    })
    this._runAction("create_database_subscription", actionData)
  }

  cancelSelection() {
    this.subscriptionSelectorTarget.classList.add("hidden")
  }
}
